export const AI_PROGRESS_STATUSES = [
  'preparing', 'counting_tokens', 'connecting', 'created', 'queued', 'in_progress', 'thinking',
  'checklist_reviewing', 'checklist_generating', 'checklist_validating', 'checklist_saving',
] as const;
export type AIProgressStatus = typeof AI_PROGRESS_STATUSES[number];
export type AILanguage = 'pl' | 'en';
export const AI_AUDIT_STATUSES = ['draft', 'active', 'processing', 'failed', 'scheduled', 'archived'] as const;

export interface AISearchGroupOption { id: string; name: string; }
export interface AISearchResults {
  version: 1;
  language: AILanguage;
  search_status: 'catalog_empty' | 'evaluated';
  as_of: string;
  today: string;
  audits: AISearchAudit[];
  coverage: {
    catalog_complete: boolean;
    selected_questions_results_complete: boolean;
    verified_groups: AISearchGroupOption[];
    unverified_groups: AISearchGroupOption[];
    partially_verified_groups: AISearchGroupOption[];
    selected_question_count: number;
  };
}
export interface AISearchAudit {
  audit_id: string;
  name: string;
  status: typeof AI_AUDIT_STATUSES[number];
  is_active: boolean;
  groups: {
    group_id: string; name: string; checklist_id: string;
    checklist_title: string; checklist_version: number;
    questions: { question_id: string; title: string }[];
  }[];
  locations: {
    location_id: string; location_name: string; role_id: number; role: string;
    last_execution: {
      execution_plan_id: string; completed_at: string; completed_at_is_estimated: boolean;
    } | null;
    next_execution: { execution_plan_id: string; planned_date: string } | null;
  }[];
}
export interface AICreatedChecklist {
  checklist_id: string;
  title: string;
  version: number;
  status: 'draft';
}

export type AIStreamEvent =
  | { kind: 'checklist_created'; checklist: AICreatedChecklist }
  | { kind: 'conversation'; conversationId: string }
  | { kind: 'status'; status: AIProgressStatus }
  | { kind: 'results'; results: AISearchResults }
  | { kind: 'delta'; text: string }
  | { kind: 'done'; text: string; status: 'completed' | 'incomplete'; refused: boolean }
  | { kind: 'error'; code: string; detail: string };

export interface AIConversationTurn {
  id: string;
  sequence: number;
  user_message: string;
  assistant_message: string;
  presentation_json: AISearchResults | null;
  checklist_result_json?: AICreatedChecklist | null;
  status: 'streaming' | 'completed' | 'incomplete' | 'failed' | 'interrupted';
  refused: boolean;
  error_code: string;
  language: AILanguage;
  created_at: string;
  finished_at: string | null;
}

export interface AIConversationHistory {
  conversation_id: string;
  results: AIConversationTurn[];
  next_before: number | null;
}

export interface AIConversationSummary {
  id: string;
  title: string;
  updated_at: string;
}
